<div class="view-request" *ngIf="!loading && record">
  <afoone-patient-request-detail
    [request]="record"
    [patient]="patient"
    [hideAcumuladosPanel]="hideAcumuladosPanel"
    [hideEpidemiologyPanel]="hideEpidemiologyPanel"
  ></afoone-patient-request-detail>
</div>
<p-progressBar *ngIf="loading" mode="indeterminate"></p-progressBar>
<p-message *ngIf="error" severity="error" [text]="error"></p-message>
